import { features } from './features'; 

features.applicationType = 'agrogest';
features.hasClients = false;
features.userCanSeeAllRecords  = true;

features.showAnalisis = false;
features.showTareasOtros = true;
features.showTareasOtrosDuracion = true;
features.showTareasFitoHoras = true;
features.showRegistroTratamiento = true;
features.showTractorBoquillas = true;
features.showTractorMarcha = true;
features.showTractorPresion = true;
features.showTractorRPM = true;
features.showTractorVelocidad = true;
features.showTractorKmRecorridos = true;
features.precioHora = true;
features.showTrabajadoresCargos = true;
features.showEnviarCorreo = true;
features.showEnviarWhatsapp = false;
features.showStock = false;
features.showStockProveedor = false;
features.showStockProveedorClienteDropdown = false;
features.showStockTipoDeDato = false;
features.showReto = true;
features.showAnalisisSectorParcelas = true;
features.showTareasGenericasObservaciones = true;
features.showTareasFertiObservaciones = true;
features.userCanSeeCostes = false;
features.showCostes = false;
features.showCostesOtros = false;
features.showTareasFitoSectorMultiple = true;
features.showRecetaPascualCabedo = true;
features.showTratamientosAllProductos = true;
features.showMapas = false;
features.showMapaTratamientos = false;
features.showMapaLabels = false;
features.showVentusky = false;
features.showTareasFitoLitrosAplicados = true;
features.activateSIEX = true;
features.showDocumentUploadVisitas = true;
features.showAplicadoSwitch = true;
features.showTareasAplicados = true;
features.showTrabajadoresFertilizantes = true;
features.showTareasPrioridad = true;
features.showVentasComercioProveedor = true;
features.showTareasBio = true;
features.showUdsCuaderno = true;
features.showCalendarioTareas = false;
features.showAplicadoresFichajes = true;
features.showAplicadoresPartes = true;
features.showFormatHourMinute = true;


export const environment = {
    production: true,
    v: '2',
    serverUrl: 'https://musina.agrogest.com/',
    logoUrl: 'assets/logo_agrogest.png',
    appName: 'musina',
    features: features
};
